"use client"

import { Zap } from "lucide-react"
import {
  PRIVACY_ICON,
  PRIVACY_COLOR,
} from "@/lib/community/showcase-constants"
import { ShieldCheck } from "lucide-react"
import type { CommunityPost } from "@/lib/community/types"

interface SkillShowcaseProps {
  skillDetail: NonNullable<CommunityPost["skillDetail"]>
}

export function SkillShowcase({ skillDetail }: SkillShowcaseProps) {
  const Icon = PRIVACY_ICON[skillDetail.privacy] ?? ShieldCheck
  const colorClass = PRIVACY_COLOR[skillDetail.privacy] ?? "text-muted-foreground"

  return (
    <div className="mb-5 space-y-2 w-fit">
      <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider flex items-center gap-1.5">
        <Zap className="h-3.5 w-3.5 text-blue-500" />
        技能信息
      </h4>

      <div className="rounded-xl border border-blue-500/15 bg-blue-500/[0.03] px-4 py-3">
        <div className="flex items-start gap-2.5">
          <Icon className={`h-4 w-4 shrink-0 mt-0.5 ${colorClass}`} />
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 flex-wrap">
              <span className="text-xs font-medium text-foreground">
                {skillDetail.name}
              </span>
              {skillDetail.installed && (
                <span className="text-nano bg-primary/10 text-primary px-1 rounded">
                  已安装
                </span>
              )}
            </div>
            <p className="text-micro text-muted-foreground mt-0.5">
              {skillDetail.role}
            </p>
            <div className="flex items-center gap-2 mt-2 text-micro">
              <span className={`px-1.5 py-0.5 rounded ${colorClass} bg-current/8`}>
                {skillDetail.privacyLabel}
              </span>
              <span className="text-muted-foreground">
                来源：{skillDetail.source}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
